export const SET = 'SET';
export const ADD = 'ADD';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const CREATE = 'CREATE';
export const COMPLETE = 'COMPLETE';
export const LOADING = 'LOADING';

export default {
  SET,
  ADD,
  UPDATE,
  DELETE,
  CREATE,
  COMPLETE,
  LOADING,
};
